'use client';

import Lines from '@/app/[locale]/(manual)/guide/[slug]/components/Lines';
import { MediaDetail } from '@/app/[locale]/(manual)/guide/[slug]/components/MediaDetail';
import Navigation from '@/app/[locale]/(manual)/guide/[slug]/components/Navigation';
import {
  ManualMainMain,
  ManualMain,
  ManualContent,
  ManualPhoto,
  ManualPhotoControls,
  ManualPhotoSlider,
  ManualPhotoSliderImg,
} from '@/ui/components/Manual/manual.styled';
import ManualLayout from '@/ui/components/Manual/ManualLayout';

export default function Loading() {
  return (
    <ManualLayout isPageLoading>
      <ManualMainMain>
        <ManualMain>
          <ManualContent>
            <Lines isLoading />
          </ManualContent>
          <ManualPhoto $isTabOpen={false}>
            <MediaDetail isPageLoading isTabOpen={true} />
            <ManualPhotoControls>
              <ManualPhotoSlider>
                <>
                  <ManualPhotoSliderImg $isPageLoading className="pulse" />
                  <ManualPhotoSliderImg $isPageLoading className="pulse" />
                  <ManualPhotoSliderImg $isPageLoading className="pulse" />
                </>
              </ManualPhotoSlider>

              <Navigation isLoading isTabOpen={true} />
            </ManualPhotoControls>
          </ManualPhoto>
        </ManualMain>
      </ManualMainMain>
    </ManualLayout>
  );
}
